import { Nullable } from '@types'

import { User } from '@modules/auth/hooks/types'

import { getEventDefaultInfo } from '../utils'

export const preparePendoSavedSearchEvent = ({
  anchorEl,
  savedSearchId,
  eventType,
  user,
}: {
  anchorEl?: Nullable<HTMLElement>
  savedSearchId?: Nullable<number>
  eventType: 'delete' | 'run' | 'overview'
  user?: User | null
}) => {
  return {
    ...getEventDefaultInfo(user),
    location: anchorEl ? 'saved_search_popover' : 'Search page',
    saved_search_id: savedSearchId,
    eventType,
  }
}
